import type Player from 'video.js/dist/types/player';

function muxAnalyticsPlugin(
  this: Player,
  options: {
    data: any;
  }
): void {
  function onLoadedMetadata(this: any) {
    this.mux?.emit('videochange', options?.data);
  }

  function onClose(this: any) {
    removeListeners();
  }

  const removeListeners = () => {
    this.off('loadedmetadata', onLoadedMetadata);
    this.off('dispose', onClose);
  };

  const addListeners = () => {
    this.on('loadedmetadata', onLoadedMetadata);
    this.on('dispose', onClose);
  };

  addListeners();
}

export default muxAnalyticsPlugin;
